import { ArrowRight, Info, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
export default function ContactCTA() {
  return <section id="contactcta" data-nav="light" className="relative bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        {/* Informative Disclaimer Note */}
        <div className="mb-10 md:mb-12">
          <Alert className="border-border/80 bg-muted/60 text-foreground py-4 px-5 rounded-xl shadow-xs">
            <Info className="size-5 text-accent shrink-0 mt-0.5" />
            <AlertDescription className="text-sm md:text-base text-muted-foreground leading-relaxed pl-1">
              Báo giá có thể thay đổi tùy theo mô hình triển khai, quy mô, khu vực và nhu cầu thực tế. Vui lòng liên hệ ROBOTO để được tư vấn phương án phù hợp.
            </AlertDescription>
          </Alert>
        </div>

        {/* Closing CTA Block */}
        <div className="relative overflow-hidden rounded-2xl md:rounded-3xl bg-foreground text-background p-8 md:p-12 lg:p-16 shadow-2xl border border-border/20">
          {/* Subtle Decorative Geometry */}
          <div className="absolute -right-20 -bottom-20 w-80 h-80 rounded-full bg-accent/15 blur-2xl pointer-events-none" aria-hidden="true" />
          <div className="absolute -left-20 -top-20 w-72 h-72 rounded-full bg-primary/20 blur-2xl pointer-events-none" aria-hidden="true" />

          <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
            <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
              Bạn đang tìm giải pháp Robotics &amp; STEM cho Trung tâm hoặc Nhà trường?
            </h2>

            <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
              Để ROBOTO tư vấn mô hình triển khai phù hợp với nhu cầu và quy mô của đơn vị.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5">
              {/* Primary Consultation Button */}
              <Button asChild size="lg" className="w-full sm:w-auto bg-accent text-accent-foreground hover:bg-accent/90 font-semibold px-8 py-6 text-base rounded-xl shadow-md transition-all hover:scale-[1.02]">
                <Link to="/FreeTrialContactPage" className="inline-flex items-center justify-center gap-2">
                  <span>ĐĂNG KÝ TƯ VẤN</span>
                  <ArrowRight className="size-4 shrink-0" />
                </Link>
              </Button>

              {/* Secondary Hotline Button */}
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-white/30 text-white bg-transparent hover:bg-white/10 hover:text-white font-medium px-8 py-6 text-base rounded-xl shadow-xs transition-all">
                <a href="tel:0346386986" className="inline-flex items-center justify-center gap-2">
                  <PhoneCall className="size-4 shrink-0 text-accent" />
                  <span>GỌI HOTLINE</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}